import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryConditions'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryConditionsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryConditionsStore",
			variables: false,
		})
	}
}

export async function load_InventoryConditions(params) {
  await initClient()

	const store = new InventoryConditionsStore()

	await store.fetch(params)

	return {
		InventoryConditions: store,
	}
}
